<template>
  <div class="dzsflgl"
       style="text-align: left; overflow-y: auto; font-size: 16px; padding-left: 10%; padding-right: 10%">
    <h1 style="text-align: justify;"></h1>
    <h1><span style="font-family: 微软雅黑;">第1章 Python基础知识与环境配置</span></h1>
    <h3 style="text-indent: 28pt;"><span style="font-family: 微软雅黑;">习题</span></h3>
    <p><span style="font-family: 微软雅黑;">1.1 简述Python提供的执行方式。</span></p>
    <p><span style="font-family: 微软雅黑;">1.2 简述Python的应用领域。</span></p>
    <p><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 28pt;"><span style="font-family: 微软雅黑;">参考答案：</span></h3>
    <p><span style="font-family: 微软雅黑;">1.1 命令执行方式和程序执行方式。</span></p>
    <p><span style="font-family: 微软雅黑;">1.2 &nbsp;程序设计、网络爬虫、人工智能、科学计算、WEB开发、系统运维、大数据、云计算、金融和图形界面等。</span></p>
    <p><span style="font-family: 微软雅黑;"> </span></p>
    <p style="text-align: left;"><br></p>
    <p style="text-align: left;"><span style="font-family: 微软雅黑;"> </span></p>
    <h1><span style="font-family: 微软雅黑;">第2章 基本程序框架与基本语法</span></h1>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 28pt;"><span style="font-family: 微软雅黑;">习题</span></h3>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">2.1 解释关键字和标识符。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">2.2 简述Python中程序设计的几种基本结构。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">2.3 简述循环结构的2种类型和基本逻辑。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">2.4 简述continue和break的用法。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">2.5 简述条件结构和循环结构的混合嵌套，并举例说明。</span></p>
    <p><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 28pt;">参考答案<span style="font-family: 微软雅黑;">：</span></h3>
    <p></p>
    <p><span style="font-family: 微软雅黑;">2.1 关键字：Python中具有特定含义的名称标识符：用于标识变量、函数、列表、元组、集合、字典和对象等名称的符号</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">2.2</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">顺序结构：在程序中，根据语句的先后顺序，依次执行每一条语句。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">选择结构：在程序中，根据条件选择执行相应的语句。即：程序中的语句是否被执行取决于条件，若条件成立，就执行相应的语句，否则不执行。</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">循环结构：在程序中，根据条件循环执行语句块（循环体）。即：程序中的语句块会被循环执行多次。</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">2.3</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">实现方法1：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">while 表达式：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;循环体</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">[else:</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;语句块]</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">实现方法2：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">for 变量 in序列：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;循环体</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">[else:</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;语句块]</span></p>
    <p><span style="font-family: 微软雅黑;">2.4</span></p>
    <p><span style="font-family: 微软雅黑;">continue：结束本次循环，进行下一次循环。</span></p>
    <p><span style="font-family: 微软雅黑;">break：退出本层循环。</span></p>
    <p><span style="font-family: 微软雅黑;">2.5</span></p>
    <p><span style="font-family: 微软雅黑;">混合嵌套：把if、for和while作为语句放入其它if、for和while的语句块中使用，从而形成多个结构中之间的相互嵌套。利用Python允许的多层嵌套，可以方便的实现复杂的数据处理。</span>
    </p>
    <p><span style="font-family: 微软雅黑;">混合嵌套的典型结构：</span></p>
    <p><span style="font-family: 微软雅黑;">if 表达式1：</span></p>
    <p><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;while 表达式2：</span></p>
    <p><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp;语句块1</span></p>
    <p><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp;if 表达式3：</span></p>
    <p><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;语句块2</span></p>
    <p><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;for x in 对象：</span></p>
    <p><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;语句块3</span></p>
    <p><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;if 表达式4：</span></p>
    <p><span
      style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;语句块4</span></p>
    <p><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;语句块5</span></p>
    <p><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;else：</span></p>
    <p><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp;语句块6</span></p>
    <p><span style="font-family: 微软雅黑;">else：</span></p>
    <p><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;语句块7</span></p>
    <p><strong> </strong></p>
    <p style="text-align: left;"><br></p>
    <p><strong> </strong></p>
    <h1><span style="font-family: 微软雅黑;">第3章 </span>基本数据类型<span style="font-family: 微软雅黑;">、运算符与运算函数</span></h1>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 28pt;"><span style="font-family: 微软雅黑;">习题</span></h3>
    <p><span style="font-family: 微软雅黑;">3.1 简述Python的基本数据类型和组合数据类型。</span></p>
    <p><span style="font-family: 微软雅黑;">3.2 解释常量，简述常量的类型。</span></p>
    <p><span style="font-family: 微软雅黑;">3.3 解释表达式，给出常用的运算符。简述表达式的类型。</span></p>
    <p><span style="font-family: 微软雅黑;">3.4 简述数据的输入方法。</span></p>
    <p><span style="font-family: 微软雅黑;">3.5 简述数据的输出方法。</span></p>
    <p><span style="font-family: 微软雅黑;">3.6 解释字符串、子串、空串、空格串和转义字符等，简述字符串的定界符。</span></p>
    <p><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 28pt;">参考答案<span style="font-family: 微软雅黑;">：</span></h3>
    <p><span style="font-family: 微软雅黑;"> </span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">3.1 </span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">整数、实数、复数、布尔和字符串；列表、元组、集合和字典等。</span></p>
    <p><span style="font-family: 微软雅黑;">3.2</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">常量：不能发生改变的数据。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">常量类型：整型常量、浮点型常量、复数型常量、字符串型常量和布尔型常量等。</span></p>
    <p><span style="font-family: 微软雅黑;">3.3</span></p>
    <p style="text-indent: 21pt;"><span
      style="font-family: 微软雅黑;">表达式：使用运算符把常量、变量、函数、列表、元组、集合和字典等按照语法规则连接起来的有效组合。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">常用运算符及其优先级：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ (，) &nbsp; &nbsp;（圆括号，可以改变优先级；最高）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ ** &nbsp; &nbsp;（乘方）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ ~ &nbsp; &nbsp;（按位取反）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ +，- &nbsp; &nbsp;（正号，负号）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ *，/，%，// &nbsp; （乘，除，求余，整除）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ +，- &nbsp; &nbsp;（加，减）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ &gt;&gt;，&lt;&lt; &nbsp; （右移，左移）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ &amp; &nbsp; &nbsp;（按位与）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ ^ &nbsp; &nbsp;（按位异或）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ | &nbsp; &nbsp;（按位或）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ &lt;=，&lt;，&gt;，&gt;=，==，!= &nbsp;（小于等于，小于，大于，大于等于，等于，不等于）</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ =,%=,/=,//=,-=,+=,*=,**= （赋值运算符）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ is，is not &nbsp; （是，不是）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ in，not in &nbsp; （在里面，不在里面）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ not &nbsp; &nbsp;（逻辑非）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ and &nbsp; &nbsp;（逻辑与）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">↓ or &nbsp; &nbsp;（逻辑或）</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">表达式类型：算术表达式、字符表达式、关系表达式和逻辑表达式等。</span></p>
    <p><span style="font-family: 微软雅黑;">3.4</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">输入数据可以使用键盘输入或读取文件等方法。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">键盘输入：可以使用[var=]input([提示字符串])实现。使用类型转换函数可以实现整数、实数、复数、逻辑数据和字符串等多种类型数据的输入。</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">读取文件：可以使用read()、readline()或readlines()实现。</span></p>
    <p><span style="font-family: 微软雅黑;">3.5</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">输入数据可以使用屏幕标准输出（IDLE）或写入文件等方法。</span></p>
    <p style="text-indent: 21pt;"><span
      style="font-family: 微软雅黑;">屏幕输出：使用print([表达式1, … ,表达式n][,sep=分隔符][,end=结束符])实现。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">写入文件：使用print()、write()、或writelines()实现。</span></p>
    <p><span style="font-family: 微软雅黑;">3.6</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">字符串常量（字符串）：用定界符括起来的一串字符。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">子字符串（子串）：包含在字符串中的字符串。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">空字符串（空串）：不含任何字符的字符串。即：长度为零的字符串。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">空格字符串：含一个或多个空格的字符串。一个空格是一个字符。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">转义字符：不能直接输入的特殊字符。转义字符以反斜杠（\）开头，后接特定字符。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">两种定界符：单引号和双引号。可以使用转义字符。</span></p>
    <p><span style="font-family: 微软雅黑;"> </span></p>
    <h1><span style="font-family: 微软雅黑;">第4章 组合数据类型</span></h1>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 30pt;"><span style="font-family: 微软雅黑;">习题</span></h3>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">4.1 简述Python的基本数据类型和组合数据类型。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">4.2 简述列表的基本概念、列表的创建和操作。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">4.3 简述元组的基本概念、元组的创建和操作。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">4.4 简述集合的基本概念、集合的创建和操作。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">4.5 简述字典的基本概念、字典的创建和操作。</span></p>
    <h3 style="text-indent: 30pt;">参考答案<span style="font-family: 微软雅黑;">：</span></h3>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">4.1</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">整数、实数、复数、布尔和字符串；列表、元组、集合和字典等。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">4.2</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">列表：由多个数据元素组成的有序序列。列表的每个元素的类型可以不同。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">4.3</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">元组（只读列表）：由多个数据元素组成的不可改变的有序序列。元组的每个元素的类型可以不同。</span>
    </p>
    <p><span style="font-family: 微软雅黑;">4.4</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">集合是由多个数据元素组成的无序序列。元组的每个元素的类型可以不同。</span></p>
    <p><span style="font-family: 微软雅黑;">4.5</span></p>
    <p style="text-indent: 21pt;"><span
      style="font-family: 微软雅黑;">字典是由多个"键：值"对组成的无序序列。字典的每个键值对的类型可以不同。字典中可以任意嵌套任何数据。</span></p>
    <p style="text-align: left;"><br></p>
    <p style="text-align: left;"><span style="font-family: 微软雅黑;"> </span></p>
    <p><span style="font-family: 微软雅黑;"> </span></p>
    <h1><span style="font-family: 微软雅黑;">第5章 程序结构与异常处理</span></h1>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 28pt;"><span style="font-family: 微软雅黑;">习题</span></h3>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">5.1 简述结构化程序设计的基本结构。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">5.2 简述选择结构的实现方法。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">5.3 简述循环结构的实现方法。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">5.4 简述continue、break和pass的用法。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">5.5 简述选择结构和循环结构的混合嵌套。举例说明典型结构。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">5.6 解释异常和异常处理。简述异常处理的语法结构。</span></p>
    <h3 style="text-indent: 28pt;"><span style="font-family: 微软雅黑;">参考答案</span></h3>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">5.1 </span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">顺序结构：在程序中，根据语句的先后顺序，依次执行每一条语句。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">选择结构：在程序中，根据条件选择执行相应的语句。即：程序中的语句是否被执行取决于条件，若条件成立，就执行相应的语句，否则不执行。</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">循环结构：在程序中，根据条件循环执行语句块（循环体）。即：程序中的语句块会被循环执行多次。</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">5.2</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">实现方法1：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">If 表达式：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;语句块A</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">[else</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;语句块B]</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">实现方法2：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">If 表达式1：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;语句块1</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">elif 表达式2：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;语句块2</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">……</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">elif表达式n：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;语句块n</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">[else</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;语句块m]</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">5.3</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">实现方法1：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">while 表达式：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;循环体</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">[else:</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;语句块]</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">实现方法2：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">for 变量 in序列：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;循环体</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">[else:</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;语句块]</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">5.4</span></p>
    <p style="text-indent: 21pt;">continue：结束本次循环，进行下一次循环。</p>
    <p style="text-indent: 21pt;">break：退出本层循环。</p>
    <p style="text-indent: 21pt;">pass：空语句（空操作），仅仅是为了满足语法上需要一个语句。</p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">5.5</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">混合嵌套：把if、for和while作为语句放入其它if、for和while的语句块中使用，从而形成多个结构中之间的相互嵌套。利用Python允许的多层嵌套，可以方便的实现复杂的数据处理。</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">混合嵌套的典型结构：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">if 表达式1：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;while 表达式2：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp;语句块1</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp;if 表达式3：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;语句块2</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;for x in 对象：</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;语句块3</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;if 表达式4：</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;语句块4</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;语句块5</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;else：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp; &nbsp; &nbsp;语句块6</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">else：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;语句块7</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">5.6</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">异常：在程序运行过程中，由于各种原因引发的错误。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">异常处理：根据出现异常的原因，确定异常的种类，设计相应的处理方案。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">异常处理语法结构：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">try：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;可能异常块</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">Except 异常名称1[，异常名称，…] [as ex1]：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;异常信息块</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">…….</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">[Except 异常名称n[，异常名称，…] [as exn]：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;异常信息块]</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">[Except：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;默认异常块]</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">[else：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;正常信息块]</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">[finally：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;永久执行块]</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <p style="text-align: left;"><span style="font-family: 微软雅黑;"> </span></p>
    <p style="text-align: left;"><br></p>
    <p style="text-align: left;"><span style="font-family: 微软雅黑;"> </span></p>
    <h1><span style="font-family: 微软雅黑;">第6章 函数与模块</span></h1>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 30pt;"><span style="font-family: 微软雅黑;">习题</span></h3>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.1 解释函数和函数体，简述函数的三要素。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.2 解释形参和实参。简述参数的三要素。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.3 解释匿名函数。举例说明。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.4 解释参数传递。简述参数传递的可变性和类型。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.5 解释局部变量和全程变量。简述global的功能。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.6 解释递归函数。 </span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.7 解释模块。简述模块包含的主要内容和模块的导入方法。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 30pt;">参考答案<span style="font-family: 微软雅黑;">：</span></h3>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.1</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">函数：具有特定功能的程序。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">函数体：具有特定功能的语句块。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">三要素：功能、参数、返回值。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.2</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">形参：形式上的参数。在设计函数时，形参可以没有确定的值，可以不指定确定的类型。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">实参：在实际使用时，拥有确定值的参数（表达式）。实参必须拥有确定的值和确定的类型。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">三要素：个数相等、顺序一致和类型一致等。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.3</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">匿名函数：利用lambda在一个语句行内，把一个表达式定义成为的函数。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">例如：fu=lambda u,v,w:u*u*u+v*v*v+w*w*w</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.4</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">参数传递：在调用函数的过程中，实参向形参传递数据的过程。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">参数可变性：不变参数，可变参数。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">不变参数：在程序中，只能使用，不可修改的参数。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">不变参数传递：把不变参数u（实参）的值，传递给函数的形参v，传递结束之后，u与v不在相关，互不影响（v仅仅接收u的值）。</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">可变参数传递：在程序中，即能使用，有可以修改的参数。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">可变参数传递：把可变参数u（实参）的id，传递给函数的形参v，传递结束之后，u与v建立了关联，同时引用一个对像。</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">参数类型：必传参数、可选（默认值）参数、关键字参数、变长参数。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.5</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">局部变量：在函数体（语句块）内部，定义的变量。局部变量的有效范围是当前函数（语句块）内部</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">全程变量：在函数外部定义的变量。全程变量的有效范围是整个程序。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">global x：把x声明为全程变量，或在函数内，使用函数外的全程变量。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.6</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">递归函数：函数直接（或间接）调用函数本身。即：自己调用自己。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">6.7</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">模块：包含变量、函数或者类的程序文件。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">内容：变量、函数或者类等。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">导入方法：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">import 模块</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">import 模块 as 新名</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">from 模块 import *：导入模块</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">from 模块 import 对象</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">from 模块 import 对象 as 新名</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <p style="text-align: left;"><br></p>
    <p style="text-align: left;"><span style="font-family: 微软雅黑;"> </span></p>
    <h1><span style="font-family: 微软雅黑;">第7章 对象与方法</span></h1>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 30pt;"><span style="font-family: 微软雅黑;">习题</span></h3>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">7.1 解释面向过程程序设计和面向对象程序设计。简述OOP的特点。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">7.2 解释类、属性、对象、事件和方法。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">7.3 简述类和对象的创建和使用方法。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">7.4 解释构造方法和析构方法。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">7.5 简述__repr__(self)和__str__(self) 的功能。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 30pt;">参考答案<span style="font-family: 微软雅黑;">：</span></h3>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">7.1</span></p>
    <p style="text-indent: 21pt;"><span
      style="font-family: 微软雅黑;">面向过程程序设计：用户为了实现具体的编程任务，使用程序语言的语句直接设计每一个求解过程的程序设计方法。</span></p>
    <p style="text-indent: 21pt;"><span
      style="font-family: 微软雅黑;">面向对象程序设计OOP：利用程序语言的类（系统提供，或用户定义），创建相应的对象，实现相应的程序设计。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">特点：类和对象的封装性、继承性和多态性等。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">7.2</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">类：一组性质相同的对象的统一抽象描述。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">属性：描述对象的数据。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">对象：客观存在的事物（拥有具体内容的类，）。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">事件：预选设定的允许对对象进行的一系列具体操作。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">方法：当事件发生后，所采取的具体处理方法。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">7.3</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">创建：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">class 类名([基类])：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;属性1=值1</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;……</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;属性n=值n</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;方法1</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;……</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> &nbsp; &nbsp;方法m</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">访问：</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">对象=类()</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">对象.属性</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">对象.方法</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">7.4</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">构造方法：__init__(self)。在创建对象时自动执行的方法。用于对象的初始化。</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">析构方法：__del__(self)。在删除对象时自动执行，可以用于删除对象后的清理工作。</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">二者可以系统自动创建，也可以用户创建。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">7.5</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">功能：重定义字符串的输出格式。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">解决：用户定义构造方法之后，数据的输出格式。</span></p>
    <p><span style="font-family: 微软雅黑;"> </span></p>
    <p style="text-align: left;"><br></p>
    <p><span style="font-family: 微软雅黑;"> </span></p>
    <h1><span style="font-family: 微软雅黑;">第8章 文件与数据库</span></h1>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 28pt;"><span style="font-family: 微软雅黑;">习题</span></h3>
    <p><span style="font-family: 微软雅黑;">8.1 解释打开文件和关闭文件。</span></p>
    <p><span style="font-family: 微软雅黑;">8.2 简述打开文件的方式。</span></p>
    <p><span style="font-family: 微软雅黑;">8.3 简述读取文件的过程。</span></p>
    <p><span style="font-family: 微软雅黑;">8.4 简述写入文件的过程。</span></p>
    <p><span style="font-family: 微软雅黑;">8.5 简述文本文件与二进制文件的主要区别。</span></p>
    <p><span style="font-family: 微软雅黑;">8.6 解释数据和数据库。简述数据库的特点。</span></p>
    <p><span style="font-family: 微软雅黑;">8.7 解释数据库管理系统。简述数据库管理系统的功能。</span></p>
    <p><span style="font-family: 微软雅黑;">8.8 解释数据库系统。简述数据库系统的组成。</span></p>
    <p><span style="font-family: 微软雅黑;">8.9 解释数据模型。简述数据模型的组成要素。</span></p>
    <p><span style="font-family: 微软雅黑;">8.10 简述数据库的模式结构。</span></p>
    <p><span style="font-family: 微软雅黑;">8.11 解释数据完整性。简述数据完整性的内容。</span></p>
    <p><span style="font-family: 微软雅黑;">8.12 简述数据库设计的步骤。</span></p>
    <p><span style="font-family: 微软雅黑;">8.13 简述数据库的基本操作。</span></p>
    <p><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 28pt;">参考答案<span style="font-family: 微软雅黑;">：</span></h3>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">8.1</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">打开文件：文件是保存在外存上的永久数据，而文件的读写是在内存中具体实施，所以在对文件进行读写时，必须先打开文件，把数据装入内存，该过程称为打开文件。</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">关闭文件：由于文件的读写是在内存中具体实施，所以在文件读写完成之后，必须把内存中的数据最终写入到外存上相应的文件中，该过程称为关闭文件。</span>
    </p>
    <p><span style="font-family: 微软雅黑;">8.2</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">文本（二进制）只写方式：w|wb。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">文本（二进制）只读方式：r|rb。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">文本（二进制）追加方式：a|ab。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">文本（二进制）读写方式：w+|wb+，r+|rb+，a+|ab+。</span></p>
    <p><span style="font-family: 微软雅黑;">8.3</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">（1）只读方式打开文件；（2）读取数据；（3）关闭文件。</span></p>
    <p><span style="font-family: 微软雅黑;">8.4</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">（1）只写（追加,读写）方式打开文件；（2）写入数据；（3）关闭文件。</span></p>
    <p><span style="font-family: 微软雅黑;">8.5</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">文本文件：读写的数据是ASCII字符。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">二进制文件：读写的数据是字节型数据。</span></p>
    <p><span style="font-family: 微软雅黑;">8.6</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">数据：表示客观事物的符号。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">数据库：长期存储在计算机内，有组织可共享的大量数据的集合（存放数据的电子仓</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">库）。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">特点：结构化存储、冗余度低，独立性高、共享和易扩展等。</span></p>
    <p><span style="font-family: 微软雅黑;">8.7</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">数据库管理系统：提供给用户，并帮助用户建立、使用和管理数据库的软件系统。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">功能：数据定义DDL、数据操纵DML、事务和运行管理、事务和运行管理DCL、组织、存储和管理数据和数据库的建立和维护等。</span>
    </p>
    <p><span style="font-family: 微软雅黑;">8.8</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">数据库系统：在计算机系统中引入数据库后，由数据库、数据库管理系统、开发工具、应用系统、数据库管理员和用户等构成的完整系统。</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">组成：硬件、软件和人员（数据库设计员、程序员、数据库管理员DBA和用户）等。</span></p>
    <p><span style="font-family: 微软雅黑;">8.9</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">数据模型：实际问题的模拟和抽象。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">组成：数据结构、数据操作和数据完整性约束等。</span></p>
    <p><span style="font-family: 微软雅黑;">8.10</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">模式结构：外模式、模式和内模式；外模式/模式和模式/内模式二级映像。三级模式和二级映像结构确保了数据独立性。</span>
    </p>
    <p><span style="font-family: 微软雅黑;">8.11</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">数据完整性（数据库完整性）：数据的正确性和相容性。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">内容：实体完整性、参照完整性和用户定义完整性等。</span></p>
    <p><span style="font-family: 微软雅黑;">8.12</span></p>
    <p style="text-indent: 21pt;"><span
      style="font-family: 微软雅黑;">需求分析（基础）、概念结构设计（桥梁）、逻辑结构设计（核心）、物理结构设计、系统实施和运行与维护等</span></p>
    <p><span style="font-family: 微软雅黑;">8.13</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">连接数据库；创建数据库、表；创建游标；记录数据的添加、修改、查询、删除和报表等。</span></p>
    <p><span style="font-family: 微软雅黑;"> </span></p>
    <p style="text-align: left;"><br></p>
    <p style="text-align: left;"><span style="font-family: 微软雅黑;"> </span></p>
    <h1><span style="font-family: 微软雅黑;">第9章 Python与数据分析</span></h1>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 28pt;"><span style="font-family: 微软雅黑;">习题</span></h3>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">9.1 简述NumPy的ndarray数组的特点；</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">9.2 简述pandas的特点；</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">9.3 创建一个一维的且长度为10的ndarray数组，其中的所有元素都为0；</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">9.4 将上一题中创建的数组中，第偶数位的所有元素的值变为1；</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">9.5 请利用pandas来生成一个三行一列的列向量(series)，列向量的行标是a,b,c，每列的值是1,2,3；</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">9.6 请利用pandas来把两个三行一列的列向量合并成一个六行一列的列向量；</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">9.7 请利用pandas生成一个三行三列的单位矩阵(dataframe)，矩阵的行标是a,b,c，矩阵的列标是e,f,g；</span>
    </p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">9.8 请自行创建一组长度为50的随机数组，并计算其平均数、中位数、标准差、方差。</span></p>
    <h3 style="text-indent: 28pt;"><span style="font-family: 微软雅黑;">参考答案：</span></h3>
    <p><span style="font-family: 微软雅黑;">9.1</span></p>
    <p><span style="font-family: 微软雅黑;">ndarray是存储单一数据类型的多维数组，NumPy库的基础就是ndarray对象，它的特点有：</span></p>
    <p><span style="font-family: 微软雅黑;">(1) ndarray对象用于存放同类型元素的多维数组；</span></p>
    <p><span style="font-family: 微软雅黑;">(2) ndarray中的每个元素在内存中都有相同存储大小的区域；</span></p>
    <p><span style="font-family: 微软雅黑;">(3) ndarray内部结构:一个指向数据(内存或内存映射文件中的一块数据)的指针、数据类型或dtype.个表示数组形状(shape)的元组(即表示各维度大小的元组)和一个跨度元组(stride)，其中的整数指的是前进到当前维度下一个元素需要跨过的字节数。</span>
    </p>
    <p><span style="font-family: 微软雅黑;">9.2</span></p>
    <p><span style="font-family: 微软雅黑;">pandas具有下列特点：</span></p>
    <p><span style="font-family: 微软雅黑;">（1）运算速度快。NumPy和pandas都是采用C语言编写，但Pandas是基于NumPy的升级版本；</span></p>
    <p><span style="font-family: 微软雅黑;">（2）消耗资源少。它采用的是矩阵运算，比Python自带的字典或者列表快很多；</span></p>
    <p><span style="font-family: 微软雅黑;">（3）可以进行各种数据运算和转换，处理数据时，比数据库、Excel等做数据处理在性能和处理速度上有较大的优势；</span></p>
    <p><span style="font-family: 微软雅黑;">（4）提供了大量的函数，为程序的编写提供了方便。</span></p>
    <p><span style="font-family: 微软雅黑;">9.3</span></p>
    <p><span style="font-family: 微软雅黑;">Import numpy as np</span></p>
    <p><span style="font-family: 微软雅黑;">Ndarry=np.zerps(10)</span></p>
    <p><span style="font-family: 微软雅黑;">9.4</span></p>
    <p><span style="font-family: 微软雅黑;">For i in range(0,9):</span></p>
    <p><span style="font-family: 微软雅黑;">Ndarry[i]=1</span></p>
    <p><span style="font-family: 微软雅黑;">9.5</span></p>
    <p><span style="font-family: 微软雅黑;">Import pandas as pd</span></p>
    <p><span style="font-family: 微软雅黑;">D={‘a’: 1 ,’b’:2 ,’c’:3}</span></p>
    <p><span style="font-family: 微软雅黑;">S=pd.series(D)</span></p>
    <p><span style="font-family: 微软雅黑;">Print(S)</span></p>
    <p><span style="font-family: 微软雅黑;">9.6</span></p>
    <p><span style="font-family: 微软雅黑;">Import pandas as pd</span></p>
    <p><span style="font-family: 微软雅黑;">D={‘a’: 1 ,’b’:2 ,’c’:3}</span></p>
    <p><span style="font-family: 微软雅黑;">S1=pd.series(D)</span></p>
    <p><span style="font-family: 微软雅黑;">S2=pd.series(D)</span></p>
    <p><span style="font-family: 微软雅黑;">S3=S2.append(S1)</span></p>
    <p><span style="font-family: 微软雅黑;">Print(S3)</span></p>
    <p><span style="font-family: 微软雅黑;">9.7</span></p>
    <p><span style="font-family: 微软雅黑;">Import pandas as pd</span></p>
    <p><span style="font-family: 微软雅黑;">df=pd.DataFrame({‘a’:[e,f,g], ’b’:[e,f,g], ‘c’:[e,f,g]})</span></p>
    <p><span style="font-family: 微软雅黑;">print df</span></p>
    <p><span style="font-family: 微软雅黑;">9.8</span></p>
    <p><span style="font-family: 微软雅黑;">略</span></p>
    <p style="text-align: left;"><br></p>
    <p style="text-align: left;"><span style="font-family: 微软雅黑;"> </span></p>
    <h1><span style="font-family: 微软雅黑;">第10章 Python与人工智能</span></h1>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 28pt;"><span style="font-family: 微软雅黑;">习题</span></h3>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">10.1 简述机器学习领域中Numpy的特点；</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">10.2 简述TensorFlow的特点；</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;">10.3 自行收集人脸图片，并识别其中的奥巴马总统。</span></p>
    <p style="text-indent: 21pt;"><span style="font-family: 微软雅黑;"> </span></p>
    <h3 style="text-indent: 28pt;"><span style="font-family: 微软雅黑;">参考答案：</span></h3>
    <p><span style="font-family: 微软雅黑;">10.1</span></p>
    <p><span style="font-family: 微软雅黑;">1.</span> <span style="font-family: 微软雅黑;">支持大量的维度数组与矩阵运算。</span></p>
    <p><span style="font-family: 微软雅黑;">2.</span> <span style="font-family: 微软雅黑;">针对数组运算提供大量的数学函数库。</span></p>
    <p><span style="font-family: 微软雅黑;">3.</span> <span style="font-family: 微软雅黑;">运行速度非常快。</span></p>
    <p><span style="font-family: 微软雅黑;">10.2</span></p>
    <p><span style="font-family: 微软雅黑;">1. TensorFlow针对速度进行了优化，并利用XLA等技术实现快速线性代数运算；</span></p>
    <p><span style="font-family: 微软雅黑;">2. 响应式构造：使用TensorFlow，我们可以轻松地将计算图的每一部分进行可视化，目前在使用NumPy时并没有这个选项；</span></p>
    <p><span style="font-family: 微软雅黑;">3. 灵活性：TensorFlow的一个非常重要的特性是，它的操作非常灵活，这意味着它实现了模块化；</span></p>
    <p><span style="font-family: 微软雅黑;">4. 易于训练：对于分布式计算，它可以很容易地在CPU上进行训练，也可以在 GPU上进行训练；</span></p>
    <p><span style="font-family: 微软雅黑;">5. 并行化神经网络训练：从某种意义上说，我们可以通过多个 GPU来训练多个神经网络，这使得模型在大型系统上非常高效；</span></p>
    <p><span style="font-family: 微软雅黑;">6. 大型社区：因为TensorFlow是由Google开发的，所以有大量软件工程师和爱好者在不断改进TensorFlow功能和性能；</span></p>
    <p><span style="font-family: 微软雅黑;">7. 开源：TensorFlow机器学习库最好的地方在于它是开源的，所以只要有互联网，任何人都可以使用它。</span></p>
    <p><span style="font-family: 微软雅黑;">10.3</span></p>
    <p><span style="font-family: 微软雅黑;">略</span></p>
  </div>


</template>

<script>
  import {qryVideoTypeList, updateVideoTypeInfo, delVideoTypeInfo} from '../../request/api';

  export default {
    data() {
      return {
        url: window.__HEALTH_URL__.JC01,
        checkAll: false,
        tableData: [],
        search: '',
        updateForm: {
          id: '',
          typeName: '',
          createDate: ''
        },
        rules: {
          typeName: [
            {required: true, message: '分类名称不能为空', trigger: 'blur'},
            {max: 50, message: '长度小于50个字符', trigger: 'blur'}
          ]
        },
        searchForm: {
          typeName: "",
        },
        dialogFormVisible: false,
        formLabelWidth: '120px',
      };
    },
    methods: {
      loadEbookTypeList() {
        let param = {
          typeName: this.searchForm.typeName
        }
        qryVideoTypeList(param).then(
          resp => {
            if (resp.code === 1) {
              // 渲染数据
              this.tableData = resp.data;
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },

      handleAdd() {
        this.dialogFormVisible = true;
        this.updateForm.id = ''
        this.updateForm.typeName = ''
      },
      handleEdit(row) {
        this.dialogFormVisible = true;
        this.updateForm = row
      },
      handleDelete(row) {
        this.$confirm('确定删除选中记录吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          let param = {
            id: row.id
          }
          delVideoTypeInfo(param).then(
            resp => {
              if (resp.code === 1) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                // 渲染数据
                this.loadEbookTypeList();
              } else {
                this.$message.error(resp.msg);
              }
            }
          ).catch(err => {
            console.log(err)
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      onSubmit() {
        this.$refs['updateForm'].validate((valid) => {
          if (valid) {
            this.dialogFormVisible = false
            let param = this.updateForm;
            updateVideoTypeInfo(param).then(
              resp => {
                if (resp.code === 1) {
                  this.$message.success(resp.msg);
                  // 重置列表
                  this.loadEbookTypeList();
                } else {
                  this.$message.error(resp.msg);
                }
              }
            ).catch(err => {
              console.log(err)
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    mounted() {
      // 加载列表
      //this.loadEbookTypeList();
    },
    props: ["itemData"]
  };
</script>

<style lang="less">
  .dzsflgl {
    background-color: #EFF3FF;
    padding: 20px;
    height: calc(100vh - 216px);
  }

  .el-table th.el-table__cell {
    background-color: #EFF3FF;
  }

  .searchClass {
    width: 900px;
    height: 70px;
    text-align: left;
    padding-left: 20px;
  }

  .searchClass .el-form-item__content {
    margin-top: 13px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .avatar-uploader {
    text-align: left;
  }

  .upload-demo {
    text-align: left;
  }

  .dzsflgl .el-table .el-table__body-wrapper {
    height: calc(100vh - 455px);
    min-height: 250px;
    overflow-y: auto;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/jc/spsflgl1.vue